module.exports = __webpack_public_path__ + "img/arrows-triangle.4033db23.svg";